module.exports = __webpack_public_path__ + "img/EnerCube1.3a25616a.jpg";